import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import type { QueryOptions, Volume } from '@partiri-cloud/types';
import { WaitingListGuard } from '../waiting-list.guard';

export class StorageApi {
  private endpoint = '/storage/volumes';

  constructor(private http: HttpClient) {}

  public list(options: QueryOptions): Observable<Volume[]> {
    const params = new HttpParams()
      .set('project', options.project)
      .set('limit', String(options.limit ?? 50));
    return this.http.get<Volume[]>(this.endpoint, { params });
  }

  public read(id: string): Observable<Volume> {
    return this.http.get<Volume>(`${this.endpoint}/${id}`);
  }

  @WaitingListGuard()
  public create(volume: Partial<Volume>): Observable<Volume> {
    return this.http.post<Volume>(`${this.endpoint}`, volume);
  }

  @WaitingListGuard()
  public attach(id: string, serviceId: string): Observable<Volume> {
    return this.http.put<Volume>(`${this.endpoint}/${id}/attach`, {
      serviceId,
    });
  }

  @WaitingListGuard()
  public detach(id: string): Observable<Volume> {
    return this.http.put<Volume>(`${this.endpoint}/${id}/detach`, {});
  }

  @WaitingListGuard()
  public update(id: string, patch: Partial<Pick<Volume, 'size' | 'mount_path'>>): Observable<Volume> {
    return this.http.patch<Volume>(`${this.endpoint}/${id}`, patch);
  }

  @WaitingListGuard()
  public delete(id: string): Observable<boolean> {
    return this.http.delete<boolean>(`${this.endpoint}/${id}`);
  }

  @WaitingListGuard()
  public retry(id: string): Observable<void> {
    return this.http.put<void>(`${this.endpoint}/${id}/retry`, {});
  }
}
